import numeral from "numeral";
import PencilIcon from "../../../components/icon/pencilIcon";
import { cn } from "../../../utils/useFunctions";
import {
  options_education_rank,
  options_under_education,
} from "../../education/functions/options";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_13,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_14,
} from "../styles/pdf.style";
import { changeDateFormat } from "./expenseInsuranceDetail.pdf";
import ViewTableFamilyInsurance from "./VITableFamilyInsurance.Main";

function ExpenseInsuranceDetailCarPDF({ page, data }) {
  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="ประกันของคุณ"
        icon="/images/insuranceClibboard.png"
        classNameIcon="w-[35px] h-[24px]"
        classNameTitle="text-[20px] font-bold"
      />

      <PdfCard
        className={"flex flex-col space-y-3"}
        title="ประกันรถยนต์"
        classNameTitle={"text-[12px] font-[500]"}
      >
        <PdfCardWhite className={cn("px-3")}>
          <div className="flex flex-row w-full space-x-[10px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                ชื่อบริษัทประกัน{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${data?.title || "-"}`}
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                กรมธรรม์ประเภท{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${data?.insurance_policy_type || "-"}`}
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full space-x-[10px] mt-[5px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                กรมธรรม์เลขที่{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${data?.insurance_policy_number || "-"}`}
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                ชื่อกรมธรรม์{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${data?.insurance_policy_name || "-"}`}
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full space-x-[10px] mt-[5px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                วันที่ของกรมธรรม์ ประกันภัย{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${data?.date_insurance_policy_makecompact? changeDateFormat(data?.date_insurance_policy_makecompact): "-"}`}
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                วันทำสัญญา ประกันภัย{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${data?.date_insurance_policy_finishcompact? changeDateFormat(data?.date_insurance_policy_finishcompact):"-"}`}
                {/* {`${data?.date_insurance_policy_finishcompact? changeDateFormat(data?.date_insurance_policy_finishcompact):"-"}`} */}
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ทุนประกัน</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center text-nowrap": true,
              })}
            >
              {`${numeral(data?.insurance_fund||0).format('0,0')} บาท`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ค่าเบี้ยประกันภัย (ต่อปี)</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center text-nowrap": true,
              })}
            >
              {`${numeral(data?.allowance_peryear||0).format('0,0')} บาท`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ผู้รับผลประโยชน์</div>
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <ViewTableFamilyInsurance data={data} />
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default ExpenseInsuranceDetailCarPDF;
